import { render, staticRenderFns } from "./ServiceProductsTooltip.vue?vue&type=template&id=5609212e&scoped=true&lang=pug&"
import script from "./ServiceProductsTooltip.vue?vue&type=script&lang=js&"
export * from "./ServiceProductsTooltip.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProductsTooltip.vue?vue&type=style&index=0&id=5609212e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5609212e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
